var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile",
    clipPath: "url(#clip0_352_846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5148 13.3439C21.5148 15.7016 19.6035 17.6129 17.2457 17.6129C14.888 17.6129 12.9767 15.7016 12.9767 13.3439C12.9767 10.9861 14.888 9.07483 17.2457 9.07483C19.6035 9.07483 21.5148 10.9861 21.5148 13.3439Z",
    stroke: "#D2D6DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6703 22.6836C10.54 22.9539 10.4729 23.2503 10.474 23.5505C10.4736 23.8531 10.5407 24.1521 10.6703 24.4255C11.0874 25.2843 12.2324 25.6768 13.1974 25.8649C13.8838 26.0189 14.581 26.12 15.2829 26.1675C15.5282 26.2166 15.7654 26.2166 16.0107 26.2166C17.0738 26.2738 18.1395 26.2574 19.2003 26.1675C19.9048 26.1194 20.6047 26.0183 21.2939 25.8649C22.2508 25.6768 23.4039 25.2843 23.8129 24.4255C24.0749 23.8744 24.0749 23.2347 23.8129 22.6836C23.4039 21.8248 22.2508 21.4323 21.2939 21.236C20.6038 21.0893 19.9042 20.9909 19.2003 20.9416C17.897 20.8271 16.5862 20.8271 15.2829 20.9416C14.5789 20.9903 13.8793 21.0887 13.1892 21.236C12.2324 21.4323 11.0792 21.8657 10.6703 22.6836Z",
    stroke: "#D2D6DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 17.5,
    cy: 17.5,
    r: 16.5,
    stroke: "#D2D6DC",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8f489658446704988b1f4c6fbfeec02e.svg";
export { ForwardRef as ReactComponent };